import { OptionEntity } from '@/types/OptionEntity';

export enum InsightsAccordionKeys {
  active = 'active',
  archive = 'archive',
}

export type InsightsAccordionItem = OptionEntity<InsightsAccordionKeys, string>;
